import { useQuery } from '@apollo/client/react';

import { AvalaraTaxItemCode, SalesTaxDocument } from '@graphql/platform';

import { useSharedCheckoutContext } from '@root/components/checkout/context';

export type TaxRateQueryState = {
  percent: number | undefined;
  loading: boolean;
  error: Error | undefined;
};

export const useStorageTaxRate = (): TaxRateQueryState => {
  const {
    flowState: { values },
  } = useSharedCheckoutContext();
  const zip = values.address?.zip?.trim() || values.zip?.trim();

  const { data, loading, error } = useQuery(SalesTaxDocument, {
    variables: {
      zipCode: zip!,
      avalaraItemCode: AvalaraTaxItemCode.Storage,
    },
    skip: !zip,
  });

  return {
    percent: data?.salesTax != null ? data.salesTax.percent : undefined,
    loading: Boolean(zip) && loading,
    error: error ?? undefined,
  };
};

/** After tax queries settle (including errors), missing rates are treated as 0%. */
export const resolvedTaxPercent = (
  state: TaxRateQueryState,
  zipPresent: boolean,
): number | undefined => {
  if (!zipPresent) return 0;
  if (state.loading) return undefined;
  return state.percent ?? 0;
};
